import { useParams, useNavigate } from 'react-router-dom';
import { Box, List, ListItem, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetProductQuery } from '../features/api/openFoodFacts/apiFoodFactsSlice';
import ProductDetails from './ProductDetails';
import Spinner from './Spinner';
import Error from './Error';

function CheckProduct() {
  const { ean } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleReturn = () => {
    navigate('/');
  };

  const handleAddProduct = () => {
    navigate(`/products/${ean}/addProduct`);
  };

  const { currentData, isLoading, isFetching, isError, isSuccess, isUninitialized } = useGetProductQuery(ean);
  const product = currentData?.product;
  if (isLoading || isFetching) {
    return <Spinner />;
  }

  if (isError) {
    return <Error />;
  }

  if (isSuccess && !isUninitialized) {
    if (product) return <ProductDetails product={product} />;

    return (
      <Box textAlign="center">
        <Typography variant="h3" align="center" sx={{ mt: 10 }}>
          {t('products.research.notFound.heading')}
        </Typography>
        <List sx={{ mt: 1 }}>
          <ListItem>{t('products.research.notFound.text')}</ListItem>
          <ListItem>
            <Button variant="contained" onClick={handleReturn}>
              {t('products.research.notFound.searchAnotherProduct')}
            </Button>
          </ListItem>
          <ListItem>
            <Button variant="contained" onClick={handleAddProduct}>
              {t('products.research.notFound.addProduct')}
            </Button>
          </ListItem>
        </List>
      </Box>
    );
  }
  return null;
}

export default CheckProduct;
